import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import iview from 'view-design'
import 'view-design/dist/styles/iview.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueMeta from 'vue-meta'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

const options = {
	fullscreenEl:false, //关闭全屏按钮
  zoomEl: false,
	bgOpacity : 0.7,
	tapToClose: true
}
Vue.use(preview, options)

import filter from './assets/js/filter'
// import 'styles/reset.css'

Vue.use(iview)

for(let key in filter){
  Vue.filter(key, filter[key])
}
Vue.prototype.$store = store
Vue.config.productionTip = false

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
